import { Pipe, PipeTransform } from '@angular/core';
import { QuestionLogicService } from '../services/question-logic.service';
import { QuestionDefinitionModel } from '../models/form/question-definition-model';
@Pipe({ name: 'targetQuestionName' })
export class TargetQuestionNamePipe implements PipeTransform {
  constructor(private questionLogicService: QuestionLogicService) {}
  transform(question: QuestionDefinitionModel): string {
    return this.questionLogicService.getTargetQuestionNames(question)[0];
  }
}
